/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Pricing_Annual_After_TrialInputs */

const en_pricing_annual_after_trial = /** @type {(inputs: Pricing_Annual_After_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount} billed yearly, after your trial`)
};

const es_pricing_annual_after_trial = /** @type {(inputs: Pricing_Annual_After_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount} al año, después de la prueba`)
};

/**
* | output |
* | --- |
* | "${amount} billed yearly, after your trial" |
*
* @param {Pricing_Annual_After_TrialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_annual_after_trial = /** @type {((inputs: Pricing_Annual_After_TrialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Annual_After_TrialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_annual_after_trial(inputs)
	return en_pricing_annual_after_trial(inputs)
});